import { $ } from '@3pc/dom';
import aniScroll from 'modules/ani-scroll';

const backToTopBtn = $('.footer__back-to-top-button');

const redirectFocus = () => {
  const skipLink = $('.skip-navigation__link');

  if (skipLink) {
    skipLink.focus();
  }
};

if (backToTopBtn) {
  backToTopBtn.addEventListener('click', () => {
    aniScroll(0, 1000, 'easeInOutQuad', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    redirectFocus();
  });
}
